import { useRef } from 'react';

import { useSiteContext } from '@zooplus/commons-lang';

import { useMetricsTransport } from '../contexts/MetricsContext';
import { createMetricsReporter } from '../services/metricsService';

export const useMetrics = (componentName: string) => {
  const transport = useMetricsTransport();
  const { site } = useSiteContext();

  const reporter = useRef(
    createMetricsReporter(transport, {
      componentName,
      componentLocation: 'CentralHub',
      productName: 'autoshipment',
      siteDomain: site.domain,
    }),
  );

  return reporter.current;
};
